import React, { useState, useEffect } from "react";
import { Device } from "@twilio/voice-sdk";
import { BASE_END_POINT } from "../../urls";
import { MDBModal } from "mdbreact";
import "./callPopup.css";
import { AudioOutlined, AudioMutedOutlined, PhoneOutlined ,PhoneFilled} from "@ant-design/icons";

export default function CallPopup({ currentUser,interestId,clientName = "Client",clientPhone = "+201221546383", clientImage }) {
  const [device, setDevice] = useState(null);
  const [status, setStatus] = useState("Disconnected");
  const [call, setCall] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [muted, setMuted] = useState(false);
console.log("Rendering CallPopup with interestId:", interestId);
  useEffect(() => {
    const initTwilio = async () => {
      try {
        const res = await fetch(`${BASE_END_POINT}twilio/getToken`,{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${currentUser.token}`,
          },
        });
        const data = await res.json(); 
        console.log("data : ",data);
        const twilioDevice = new Device(data.token, { codecPreferences: ["opus", "pcmu"] }); 
        twilioDevice.on("ready", () => setStatus("Ready")); 
        twilioDevice.on("error", (err) => setStatus("Error: " + err.message)); 
        twilioDevice.on("incoming", (conn) => { setShowPopup(true); 
        setStatus("Incoming Call"); setCall(conn); }); 
        setDevice(twilioDevice);
      } catch (err) {
        console.error(err);
      }
    };

    initTwilio();
  }, []);

  const startCall = async (toNumber) => {
    if (!device) return;
    console.log("Starting call to:", toNumber, "with interestId:", interestId);
    //const conn = await device.connect({ params: { To: toNumber } });
    const conn = await device.connect({ 
      params: { 
        To: toNumber,
        userId:currentUser.user.id,
        interestId:interestId,
        fromPhone:currentUser.user.phone?currentUser.user.phone:"+17815796702"
      }
    });
    setCall(conn);
    setShowPopup(true);
    setStatus("Calling...");
    setCallDuration(0);

    conn.on("ringing", () => setStatus("Ringing..."));

    conn.on("accept", () => {
      setStatus("In Call");
      let sec = 0;
      const interval = setInterval(() => {
        sec++;
        setCallDuration(sec);
      }, 1000);

      conn.on("disconnect", () => {
        clearInterval(interval);
        setStatus("Disconnected");
        setShowPopup(false);
        setCall(null);
        setCallDuration(0);
      });
    });

    conn.on("error", (err) => setStatus("Error: " + err.message));
  };

  const endCall = () => {
    if (call) call.disconnect();
    setStatus("Disconnected");
    setShowPopup(false);
    setCall(null);
    setCallDuration(0);
  };

  const toggleMute = () => {
    if (call) {
      if (muted) {
        call.mute(false);
        setMuted(false);
      } else {
        call.mute(true);
        setMuted(true);
      }
    }
  };

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div className="call-popup">
        {/* زر الاتصال */}
        <button 
          type="button" 
          className="call-btn" 
          onClick={() => startCall(clientPhone)}
        >
          <PhoneFilled />
        </button>

        {/* مودال الاتصال */}
        <MDBModal isOpen={showPopup} centered backdrop={true}>
            <div className="phone-emulator">
                {/* صورة المستخدم */}
                <img
                    src={clientImage || require("../../assets/images/logoC.png")}
                    alt="User"
                    className="caller-img"
                />

                {/* الاسم */}
                <h2 className="caller-name">{clientName}</h2>

                {/* الحالة */}
                <p className="call-status">{status}</p>

                {/* العداد */}
                <div className="call-timer">{formatTime(callDuration)}</div>

                {/* الأزرار */}
                <div className="controls">
                    <button type="button" className="control-btn mute" onClick={toggleMute}>
                        {muted ? <AudioMutedOutlined style={{ fontSize: "28px", color: "white" }} /> 
                            : <AudioOutlined style={{ fontSize: "28px", color: "white" }} />}
                    </button>

                    <button type="button" className="control-btn end" onClick={endCall}>
                        <PhoneOutlined style={{ fontSize: "28px", color: "white" }} rotate={225} />
                    </button>
                </div>

            </div>
        </MDBModal>
    </div>
  );
}
